
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-engines",
      function () {
        return require("private-next-pages/growth-engines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/growth-engines"])
      });
    }
  